module.exports = __webpack_public_path__ + "img/lyon01.e6042302.jpg";